var _g, _g2, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFuterImg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 119,
    viewBox: "0 0 124 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_167_564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.804 3H14.1956C8.56472 3 4 9.50165 4 17.5218V99.4782C4 107.498 8.56472 114 14.1956 114H109.804C115.435 114 120 107.498 120 99.4782V17.5218C120 9.50165 115.435 3 109.804 3Z",
    fill: "url(#paint0_linear_167_564)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_167_564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.035 9H19.9651C15.0138 9 11 13.4516 11 18.9429V75.0571C11 80.5484 15.0138 85 19.9651 85H104.035C108.986 85 113 80.5484 113 75.0571V18.9429C113 13.4516 108.986 9 104.035 9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.035 9H19.9651C15.0138 9 11 13.4516 11 18.9429V75.0571C11 80.5484 15.0138 85 19.9651 85H104.035C108.986 85 113 80.5484 113 75.0571V18.9429C113 13.4516 108.986 9 104.035 9Z",
    stroke: "url(#paint1_linear_167_564)",
    strokeWidth: 0.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104 16.8982V71.1018C103.998 72.1364 103.583 73.1279 102.847 73.8588C102.111 74.5896 101.113 75 100.073 75C99.9186 74.647 99.7387 74.3055 99.535 73.9781L82.7766 47.5067C82.1602 46.5382 81.3076 45.7405 80.2981 45.1878C79.2886 44.635 78.155 44.3452 77.0028 44.3452C75.8505 44.3452 74.7169 44.635 73.7075 45.1878C72.698 45.7405 71.8454 46.5382 71.2289 47.5067L62.3237 61.3523L46.6671 36.6281C46.0571 35.6631 45.2129 34.8663 44.2124 34.3108C43.2118 33.7553 42.0869 33.459 40.9411 33.4492C39.7953 33.4393 38.6655 33.7163 37.6554 34.2545C36.6453 34.7927 35.7875 35.5749 35.1608 36.5292L23 54.9982V16.8982C23.0022 15.8636 23.4169 14.8721 24.153 14.1413C24.8891 13.4105 25.8866 13 26.9266 13H100.073C101.113 13 102.111 13.4105 102.847 14.1413C103.583 14.8721 103.998 15.8636 104 16.8982Z",
    fill: "url(#paint2_linear_167_564)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84 36C87.866 36 91 32.866 91 29C91 25.134 87.866 22 84 22C80.134 22 77 25.134 77 29C77 32.866 80.134 36 84 36Z",
    fill: "url(#paint3_linear_167_564)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_167_564",
    x: 0,
    y: 0,
    width: 124,
    height: 119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_167_564"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_167_564",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_167_564",
    x: -39.4299,
    y: -41.4299,
    width: 202.86,
    height: 176.86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_167_564"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_167_564",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_167_564",
    x1: 62,
    y1: 3,
    x2: 62.5352,
    y2: 127.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8253D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#8A4FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF16BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_167_564",
    x1: 62,
    y1: 85.6162,
    x2: 62,
    y2: 8.39783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_167_564",
    x1: 33.7028,
    y1: 5.50033,
    x2: 98.3722,
    y2: 70.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30F3D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0367ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_167_564",
    x1: 79.0484,
    y1: 24.0484,
    x2: 88.9516,
    y2: 33.9516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE1A86"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuterImg2);
export default __webpack_public_path__ + "static/media/futer_img2.a4e702f2f684ab5d5d33ca705fb288ff.svg";
export { ForwardRef as ReactComponent };